import { Component, OnInit } from '@angular/core';
import { tap } from 'rxjs/operators';
import { MessageService } from './message.service';

@Component({
  selector: 'claim',
  templateUrl: './product-detail-claim.component.html',
  styleUrls: ['./product-detail-claim.component.scss']
})
export class ProductDetailClaimComponent implements OnInit {
  removeHeader$ = this.messageService.congratsInit$;
  constructor(private messageService: MessageService) { }

  ngOnInit() {
  }

}
